module.exports = __webpack_public_path__ + "static/media/upload_drop_file.edac49f3.png";